import { render, staticRenderFns } from "./WickSamples.vue?vue&type=template&id=4e1adb08&scoped=true"
import script from "./WickSamples.vue?vue&type=script&lang=js"
export * from "./WickSamples.vue?vue&type=script&lang=js"
import style0 from "./WickSamples.vue?vue&type=style&index=0&id=4e1adb08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1adb08",
  null
  
)

export default component.exports